import React from 'react';
import styled, { StylesProps } from '../../../lib/styles';
import popularSectionStyles from './PopularBlock_styles';
import { Article, Author } from '../../../models/article';
import Spacer from '../../../components/presentational/Spacer';
import StoryAuthor from '../../../components/presentational/StoryAuthor';
import LightStory from '../../../components/presentational/Story/LightStory';

export interface PopularBlockProps {
  authors?: Author[];
  articles?: Article[];
  slotKey?: string;
}

const PopularBlock = ({
  authors = [],
  articles = [],
  slotKey,
  styles,
}: PopularBlockProps & StylesProps<typeof popularSectionStyles>) => (
  <div className={styles.container}>
    {authors.length > 0 && (
      <Spacer flex={'1 1 0%'} space={'m'}>
        <h1 className={styles.title}>Expert contributors</h1>

        {authors.map((author: Author, i: number) => (
          <StoryAuthor key={i} size={'l'} tagline vane link author={author} />
        ))}
      </Spacer>
    )}

    {articles.length > 0 && (
      <Spacer flex={'1 1 0%'} space={'m'}>
        <h1 className={styles.title}>Most popular</h1>

        {articles.map((article: Article, i: number) => (
          <Spacer key={i} row space={'m'} align={'center'}>
            <div className={styles.num}>{i + 1}</div>
            <Spacer flex={'auto'}>
              <LightStory
                slot={slotKey && `${slotKey}-slot-${i + 1}`}
                vane
                article={article}
              />
            </Spacer>
          </Spacer>
        ))}
      </Spacer>
    )}
  </div>
);

export default styled(popularSectionStyles)(PopularBlock);
